import { toast } from "@kyan/ui";

export const copy = (content: string) => {
  navigator.clipboard.writeText(content);
  toast.success({ title: "Copied to clipboard" });
};
